import { QueryClient } from '@tanstack/react-query'

/** O cache de leitura do app. Em teste, sem repetição: o erro aparece na hora. */
export function createQueryClient(options: { retry?: boolean } = {}) {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Erro com causa e caminho vem da API; repetir sozinho só esconde o problema.
        retry: options.retry === false ? false : 1,
        refetchOnWindowFocus: false,
        staleTime: 15_000,
      },
      mutations: { retry: false },
    },
  })
}
